import { Divider, FormControl, Grid, Hidden, TextField, Typography } from "@mui/material";
import moment from "moment";
import HESPFormLabel from "../HESPFormLabel/HESPFormLabel";
import styled from "styled-components";
import * as React from "react";
import { DateTimePicker } from "@mui/x-date-pickers";

import { ReportObject } from "./ManageReportForm";

interface Props {
    reportObj: ReportObject;
    initObj: ReportObject;
    onChangeStart: (newValue: string) => void;
    onChangeEnd: (newValue: string) => void;
    onChangeName: (newValue: string) => void;
    onChangeClientId: (newValue: string) => void;
    firstSubmitDone: boolean;
    isActive: boolean;
    isCreate: boolean;
}

const DateInfo = styled.div`
    background-color: ${(props) => props.theme.lightBlueBackground};
    font-size: 13px;
    padding: 10px;
    width: 100%;
    border-radius: 8px;
    margin-top: 10px;
`;

export default function ReportBasicsForm({
    reportObj,
    initObj,
    onChangeEnd,
    onChangeStart,
    onChangeName,
    onChangeClientId,
    firstSubmitDone,
    isCreate,
    isActive,
}: Props) {
    const { end, name, start, clientId } = reportObj;

    const shortTzName = new Date()
        .toLocaleDateString("en-US", {
            day: "2-digit",
            timeZoneName: "short",
        })
        .slice(4);

    function getStartMessage() {
        return (
            <>
                <div>
                    <strong>UTC: </strong>
                    {moment(start).utc().format("MMM DD, YYYY HH:mm")}
                </div>
                <div>
                    <strong>{shortTzName}</strong>: {moment(start).format("MMM DD, YYYY HH:mm")}
                </div>
            </>
        );
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                    <HESPFormLabel label="Name" />
                    <TextField
                        variant="outlined"
                        fullWidth
                        defaultValue={name}
                        placeholder="Name of report"
                        onChange={(e: any) => onChangeName(e.target.value)}
                        name="name"
                    />
                    {name?.trim().length === 0 && firstSubmitDone && (
                        <Typography variant="subtitle2" color="error">
                            Please enter a name
                        </Typography>
                    )}
                </FormControl>
            </Grid>
            <Hidden mdDown>
                <Grid item md={6}></Grid>
            </Hidden>
            <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                    <HESPFormLabel
                        label="Your unique identifier (optional)"
                        description="A unique identifier that you can set and that will be included in reporting"
                    />
                    <TextField
                        variant="outlined"
                        fullWidth
                        defaultValue={clientId}
                        placeholder="Your identifier"
                        onChange={(e: any) => onChangeClientId(e.target.value)}
                    />
                </FormControl>
            </Grid>
            <Hidden mdDown>
                <Grid item md={6}></Grid>
            </Hidden>
            <Grid item xs={12} style={{ marginTop: "6px", marginBottom: "6px" }}>
                <Divider />
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
                <HESPFormLabel label="Start" />
                <FormControl>
                    <DateTimePicker
                        format="YYYY/MM/DD HH:mm"
                        ampm={false}
                        value={moment(start)}
                        // minDateTime={isActive ? undefined : moment().startOf("minute").add(2, "minutes")}
                        onChange={(newValue: moment.Moment | null) => {
                            if (newValue !== null) {
                                onChangeStart(newValue.startOf("minute").toISOString());
                            }
                        }}
                    />

                    <DateInfo>{getStartMessage()}</DateInfo>
                </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} lg={3}>
                <HESPFormLabel label="End" />
                <FormControl>
                    <DateTimePicker
                        format="YYYY/MM/DD HH:mm"
                        ampm={false}
                        value={moment(end)}
                        minDate={moment(start)}
                        minTime={moment(start).date() === moment(end).date() ? moment(start) : undefined}
                        disableIgnoringDatePartForTimeValidation
                        onChange={(newValue: moment.Moment | null) => {
                            if (newValue !== null) {
                                onChangeEnd(newValue.startOf("minute").toISOString());
                            }
                        }}
                    />

                    <DateInfo>
                        <div>
                            <strong>UTC: </strong>
                            {moment(end).utc().format("MMM DD, YYYY HH:mm")}
                        </div>
                        <div>
                            <strong>{shortTzName}</strong>: {moment(end).format("MMM DD, YYYY HH:mm")}
                        </div>
                    </DateInfo>
                </FormControl>
            </Grid>
            <Grid item xs={12}>
                <Divider style={{ marginTop: "10px" }} />
            </Grid>
        </Grid>
    );
}
